type VoiceSandboxWindow = Window & {
  __FINTHEON_VOICE_WIDGET_SANDBOX__?: boolean;
};

export function isVoiceWidgetSandboxPreview(): boolean {
  if (typeof window === "undefined") return false;
  const sandboxWindow = window as VoiceSandboxWindow;
  if (sandboxWindow.__FINTHEON_VOICE_WIDGET_SANDBOX__ !== true) return false;
  const params = new URLSearchParams(window.location.search);
  return params.get("simulateMic") === "1" || params.get("mockMic") === "1";
}
